export default {
  title: {
    id: 'product_macbook_processor_modal_title',
    defaultMessage: 'Processor',
  },
}
